import _memoize from 'lodash/memoize';
import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { identity } from '../utils/sizes';
import { cacheResolver, makeDefaultStylingContext } from '../utils/style';
import { FIRST_BLOCK_PADDING, PADDING, TITLE_PADDING } from './block.constants';

export * from './block.constants';

export const defaultContext = makeDefaultStylingContext();

export const EMPTY_BLOCK_STYLE = { title: {}, items: {} };

export const BACKGROUND_INITIAL_ALPHA = 0.001;

export const BACKGROUND_LOADED_ALPHA = 1;

export const colors = {
  title: makeThemeColor(PRIMARY),
};

export const getTitleStyle = _memoize(
  ({ screenSize, colorMode }) => ({
    y: TITLE_PADDING.TOP[screenSize],
    color: colors.title[colorMode],
    text: {
      ...getFont(FONT.KINSHASA_3, screenSize),
      verticalAlign: 'middle',
    },
  }),
  cacheResolver,
);

/**
 * Provides dynamic List block styles that depends on externally provided context(existence of row title and row index)
 */
export const getBlockStyle = _memoize(context => {
  const { hasTitle, isFirstBlock, screenSize, isSearchPage } = context;

  const padding = {
    top: PADDING.TOP[screenSize],
    bottom: PADDING.BOTTOM[screenSize],
    left: PADDING.LEFT[screenSize],
  };
  const firstBlockPadding = isSearchPage ? 10 : FIRST_BLOCK_PADDING[screenSize];
  const titleStyle = getTitleStyle(context);
  const items = { y: padding.top };
  const title = { y: titleStyle.y };

  if (hasTitle) {
    items.y = titleStyle.text.lineHeight + TITLE_PADDING.BOTTOM[screenSize];

    if (isFirstBlock) {
      items.y += firstBlockPadding;
      title.y = firstBlockPadding;
    } else {
      items.y += titleStyle.y;
    }
  } else if (isFirstBlock) {
    items.y = firstBlockPadding;
  }

  return { title, items, padding };
}, cacheResolver);

export const getInitialStyle = (context = defaultContext) => ({
  Background: {
    w: identity,
    h: identity,
  },
  Row: {
    rightPadding: PADDING.RIGHT[context.screenSize],
  },
  Title: getTitleStyle(context),
});
